import React, { useState, useEffect, useRef, useContext } from 'react';
import { Home }  from "./Home";
import { useHistory, useLocation } from 'react-router-dom';

import useNetwork from '../useNetwork';
import { Modal, Dropdown } from 'bootstrap';
import { AppDataContext, VLink } from "./AppDataContext";
import LoginAndRegistration from "./LoginAndRegistration";

export function Header (props) {
    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(false);
    const history = useHistory();
    const location = useLocation();

    const [searchValue, setSearchValue] = useState(null);

    const loggedIn = () => {
        Modal.getInstance('#loginModal').hide();
    };

    const loggedInOrRegistered = () => {
        Modal.getInstance('#loginOrRegisterModal').hide();
    };

    const registered = () => {
        Modal.getInstance('#registerModal').hide();
    };

    const loadIfAuth = async () => {

        let url = 'api/site/isauth';
        const response = await netRequest(url);

        if (response.data != null) {
            context.loggedIn(response.data);
        } else {
            context.loggedOut();
        }
    }

    useEffect(() => {
        // whenever we mount, check if they are logged in, which will check with the login cookie, if set
        const loadIfAuthAsync = async () => {
            await loadIfAuth();                     
        };
        loadIfAuthAsync();

        // clean up when out of scope
        return () => {
        };
    }, []);

    const logOut = async () => {

        let url = 'api/site/logout';
        const response = await netRequest(url);

        if (response.data == null) {

            context.loggedOut();

            // call back to the server to reset any validation tokens
            await loadIfAuth();
        }
    }

    const dismissAlert = async (alert) => {
        const url = 'api/site/dismissalert';
       
        const postData = {
            Param: alert.secureId,
        };

        // when this is the last alert, close the notification before we return
        if (context.alerts.length == 1)
            Dropdown.getInstance("#alertsDropdown").hide();

        const response = await netRequest(url, postData);
        if (response.isError == false)
        {
            var newAlerts = [...context.alerts];
            // remove the dismissed alert.
            let ix = newAlerts.indexOf(alert);
            if (ix > -1) {
                newAlerts.splice(ix, 1);
            }

            context.setAlerts(newAlerts);
        }
    }
    const dismissAllAlerts = async () => {
        const url = 'api/site/dismissalerts';

        // close the notification before we return
        Dropdown.getInstance("#alertsDropdown").hide();

        const response = await netRequest(url, {});
        if (response.isError == false)
        {
            context.setAlerts([]);
        }
    }


    const handleSearchKeyPress = (evt) => {
        if (evt.key === 'Enter' && evt.target.value && evt.target.value != '') {
            history.push('/search', { searchText: evt.target.value });
        }
    }

    const updateSearchValue = (evt) => { setSearchValue(evt.target.value); };

    useEffect(() => {
        if (location.pathname.endsWith('/search') == false) {
            setSearchValue('');
        }

        // hide any open header modals on navigate
        Modal.getInstance("#loginModal")?.hide();
        Modal.getInstance("#loginOrRegisterModal")?.hide();
        Modal.getInstance("#registerModal")?.hide();


        // when opening a bootstrap modal and clicking back while the modal is open the backdrop does not get removed.
        // this is a heavy handed hack to remove the backdrop

        var backdrops = document.getElementsByClassName("modal-backdrop");
        if (backdrops.length > 0) {
            backdrops[0].remove();
            document.body.classList.remove('modal-open');
            document.body.removeAttribute('style');
        }

    }, [location.pathname]);

    //if (networkError) {
    //    return netRenderError();
    //}

    return (
     
        <header class="">
            <nav class="navbar navbar-expand-lg navbar-light white">

                <div class="container">
                    <div class="d-none d-lg-block form-inline my-2 my-lg-0 search">
                        <div class="ms-0 input-group flex-nowrap">
                            <span class="input-group-text">
                                <i class="bi bi-search"></i>
                            </span>
                            <input class="form-control" type="search" placeholder="Search" aria-label="Search"
                                onKeyDown={evt => handleSearchKeyPress(evt)}
                                onChange={evt => updateSearchValue(evt)}

                                value={searchValue}
                            />
                        </div>
                    </div>

                    <VLink className="navbar-brand d-block" to="/" ><img src="images/bnd-logo@2x.png" height="" title="Bid Next Door" alt="Bid Next Door Logo" /></VLink>

                    
                    {!context.isLoggedIn ?
                        (
                            <ul class="navbar-nav bnd-menu">
                                <li class="nav-item ms-auto">
                                    <a class="nav-link" href="#" data-bs-toggle="modal" data-bs-target="#loginModal" title="Log In">Log In</a>
                                </li>
                                <li class="nav-item">
                                    <a href="#" class="nav-link btn btn-secondary" data-bs-toggle="modal" data-bs-target="#registerModal" title="Register">Sign Up</a>
                                </li>
                            </ul>
                        ) :
                        ( 
                            <ul class="navbar-nav bnd-menu">
                                <li class="nav-item ms-auto">
                                    <div class="dropdown">
                                        <button id="alertsDropdown" type="button" class="nav-link ms-auto notifications"
                                            data-bs-auto-close="outside"
                                            data-bs-toggle={context.alerts?.length > 0 ? "dropdown" : null}
                                            title="Notifications"
                                            data-bs-trigger="focus">

                                            <i class="bi bi-bell-fill">
                                                {(context.alerts && context.alerts.length > 0) &&
                                                        <span>{context.alerts?.length}</span>
                                                }
                                            </i>
                                        </button>
                                               
                                        <ul class="dropdown-menu notifications-list" aria-labelledby="dropdownMenuButton1">
                                            {context.alerts?.length > 1 &&
                                                <li class="px-3 py-1 notifications-list__item dropdown-item">
                                                    <a onClick={dismissAllAlerts} class="btn  btn-primary  w-100">Clear All Notifications</a>
                                                </li>
                                            }
                                            {
                                                context.alerts?.map((al) =>

                                                <li key={al.secureId} class="d-flex justify-content-between position-relative notifications-list__item dropdown-item">

                                                       
                                                        <VLink to={al.secureLotId == null ? '/auction/' + al.secureAuctionSessionId : '/auction/' + al.secureAuctionSessionId + '/lot/' + al.secureLotId} class="align-self-center">
                                                        
                                                        {al.alertEnumName == 'BidderUserAuctionApproved' ?
                                                            <span class="label auction-label won">Approved</span>
                                                            :
                                                            al.alertEnumName == 'BidderOutbid' ?
                                                                <span class="label auction-label outbidded">Outbid</span>
                                                            :
                                                            al.alertEnumName == 'BidderWins' ?
                                                                <span class="label auction-label won">Won</span>
                                                            :
                                                            al.alertEnumName == 'HighBidAfterRetract' ?
                                                                <span class="label auction-label won">High Bid</span>
                                                            :
                                                            al.alertEnumName == 'FavoriteBidOn' ?
                                                                <span class="label auction-label pending">Favorite Bid On</span>
                                                            :
                                                            al.alertEnumName == 'SellerPublishedAuction' ?
                                                                <span class="label auction-label won">Published</span>
                                                            :
                                                            al.alertEnumName == 'Test' ?
                                                                <span class="label auction-label won">Test</span>
                                                            :
                                                                <></>}
                                                        {al.messageText}
                                                    </VLink>
                                                    <a onClick={() => dismissAlert(al)} class="btn btn-icon-only btn-no-border btn-secondary position-absolute btn-dismiss-notification" ><i class="bi bi-x"></i></a>
                                                        
                                                </li>
                                              

                                                )
                                            }
                                           
                                        </ul>

                                    </div>

                                    </li>
                                   
                                <li class="nav-item user-details has-children">
                                    <VLink to="/account" class="nav-link text-nowrap" title="My Account"><span class="user-initials">{context.initials}</span></VLink>
                                </li>                                  
                                <li class="nav-item">
                                    <VLink to="/dashboard" class="nav-link btn btn-fill btn-secondary" title="Dashboard"><i class="bi bi-star-fill"></i><span class="d-none d-md-inline ms-2">Dashboard</span></VLink>
                                </li>
                                
                            </ul>
                        )
                    }
                    
                </div>
                <div class="d-block w-100 my-1">
                    <div class="container">
                        <div class="d-inline-block d-lg-block">
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="true" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>

                            <div class="collapse navbar-collapse justify-content-between p-3 p-lg-0" id="navbarSupportedContent">
                                <div class="d-block d-lg-none py-3">
                                    <VLink className="navbar-brand d-block" to="/" ><img src="images/bnd-logo@2x.png" height="" title="Bid Next Door" alt="Bid Next Door Logo" /></VLink>
                                    <button type="button" class="btn-close" aria-label="Close" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-expanded="false" aria-controls="navbarSupportedContent"></button>
                                </div>
                                <ul class="  inline-links py-3 py-lg-0">
                                    <li><VLink class="ps-0" to="/about" title="About Us">About Us</VLink></li>
                                    <li><VLink to="/sell" title="Sell on Bid Next Door">Sell on Bid Next Door</VLink></li>
                                    <li><VLink to="/faq" title="FAQs">FAQs</VLink></li>
                                    
                                </ul>
                            </div>
                        </div>
                        <div class="d-block d-lg-none search-mobile">
                            <div class="input-group flex-nowrap">
                                <span class="input-group-text">
                                    <i class="bi bi-search"></i>
                                </span>
                                <input class="form-control" type="search" placeholder="Search" aria-label="Search"
                                    onKeyDown={evt => handleSearchKeyPress(evt)}
                                    onChange={evt => updateSearchValue(evt)}

                                    value={searchValue}
                                />
                            </div>
                        </div>
                    </div>
                </div>	
            </nav>
            <div class="modal fade" id="loginModal" tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <img src="images/bnd-logo@2x.png" height="" title="Bid Next Door" alt="Bid Next Door Logo" />
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">

                            <LoginAndRegistration
                                showLogin={true}
                                showSignup={false}
                                registrationComplete={loggedIn}
                            />

                        </div>

                    </div>
                </div>
            </div>
            <div class="modal fade" id="loginOrRegisterModal" tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <img src="images/bnd-logo@2x.png" height="" title="Bid Next Door" alt="Bid Next Door Logo" />
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">

                            <LoginAndRegistration
                                showLogin={true}
                                showSignup={true}
                                registrationComplete={loggedInOrRegistered}
                            />

                        </div>

                    </div>
                </div>
            </div>
            <div class="modal fade" id="registerModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <img src="images/bnd-logo@2x.png" height="" title="Bid Next Door" alt="Bid Next Door Logo" />
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <LoginAndRegistration
                                showLogin={false}
                                showSignup={true}
                                showBackToLogin={false}
                                registrationComplete={registered}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </header>
 
            
    );
}
